import React from 'react'
import ReactTooltip from 'react-tooltip'

export default function Tooltip(props) {
    const {tooltipId} = props;
    const TEUsTooltip = "The 20-foot container is the smallest container typically handled at global ports. The Twenty-foot Equivalent Container Unit is the maritime shipping industry's unit of measure for capacity and volumes handled. One 40-foot container is two TEUs.";
    const TONsTooltip = "The Georgia Ports Authority uses the short ton, a mass measurement unit equal to 2,000 pounds, to track its cargo.";
    const employmentTooltip = "Port activity in Georgia supports jobs directly and indirectly related to marine terminals, such as port employees, stevedores, longshoremen, trucking, rail, warehousing, agriculture, manufacturing, and services such as finance and real estate.";

    const tipcontent = () => {
        switch(tooltipId) {
            case 'TEUs_tooltip':
                return TEUsTooltip;
            case 'TONs_tooltip':
                return TONsTooltip;
            case 'employment_tooltip':
                return employmentTooltip;
            default:
                return '';
        }
    }

    return (
        <>
            <span data-tip='tooltip' data-for={tooltipId} className="tooltip-icon"><span className="sr-only">what's this?</span></span>            
            <ReactTooltip id={tooltipId} >
                {tipcontent()}
            </ReactTooltip>
        </>
    )

}